import { RequestPayload } from "appworks/model/gameplay/requests/request-payload";

export class PickRequestPayload extends RequestPayload {
    public pick: string | number;
}
